var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 21,
    viewBox: "0 0 62 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visa logo",
    clipPath: "url(#clip0_669_11307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M26.9493 20.1134H22.0742L25.1235 1.17981L29.9983 1.17981L26.9493 20.1134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M44.6216 1.63823C43.66 1.25514 42.1348 0.832153 40.249 0.832153C35.4346 0.832153 32.0444 3.4102 32.0236 7.09604C31.9836 9.81544 34.4509 11.3259 36.2963 12.2326C38.1824 13.1591 38.8235 13.7639 38.8235 14.5898C38.8043 15.8582 37.2994 16.4429 35.8958 16.4429C33.9495 16.4429 32.9066 16.1414 31.3217 15.4358L30.6798 15.1332L29.9976 19.3834C31.141 19.9065 33.2475 20.3707 35.4346 20.3911C40.5499 20.3911 43.8802 17.8529 43.9196 13.9251C43.9391 11.7697 42.6363 10.1182 39.8275 8.76869C38.1224 7.90238 37.0782 7.31824 37.0782 6.43185C37.0982 5.62604 37.9614 4.80069 39.8861 4.80069C41.471 4.76027 42.6355 5.14282 43.5176 5.52565L43.9586 5.7267L44.6216 1.63823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M51.1012 13.4059C51.5027 12.3182 53.0475 8.10842 53.0475 8.10842C53.0273 8.14884 53.4482 7.00063 53.689 6.29575L54.0297 7.92718C54.0297 7.92718 54.9528 12.4592 55.1533 13.4059C54.3914 13.4059 52.0641 13.4059 51.1012 13.4059ZM57.1189 1.17981L53.348 1.17981C52.1851 1.17981 51.3017 1.52194 50.7999 2.75073L43.5586 20.1131H48.6739C48.6739 20.1131 49.516 17.7762 49.6971 17.2729C50.2582 17.2729 55.2344 17.2729 55.9563 17.2729C56.0962 17.9377 56.538 20.1131 56.538 20.1131H61.0519L57.1189 1.17981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M18.002 1.17981L13.2277 14.0907L12.706 11.4722C11.8233 8.45082 9.05505 5.16816 5.96582 3.53593L10.3389 20.0933H15.4942L23.157 1.17981H18.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M8.79441 1.17981L0.950848 1.17981L0.870605 1.56237C6.98908 3.13356 11.0412 6.92086 12.7061 11.473L11.001 2.77135C10.7202 1.5621 9.85757 1.2197 8.79441 1.17981Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_11307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.1813,
    height: 19.5589,
    fill: "white",
    transform: "translate(0.871094 0.839966)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.fd29eae3f3eb53b2f8966bb40741e082.svg";
export { ForwardRef as ReactComponent };